module.exports = __webpack_public_path__ + "img/kaichuang.57c4beac.png";